<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">医生评价管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 200px; margin: 0 30px 0 8px"
              @input="search"
              clearable=""
            ></el-input>
            <span>医生手机</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width: 200px; margin: 0 12px 0 8px"
              @input="search"
              clearable=""
            ></el-input>
            <span>医生评价展示</span>
            <el-radio-group
              v-model="is_show_evaluate"
              style="margin: 0 12px 0 8px"
            >
              <el-radio label="-1">全部</el-radio>
              <el-radio label="1">开启</el-radio>
              <el-radio label="0">关闭</el-radio></el-radio-group
            >

            <el-button
              type="info"
              @click="search"
              style="background-color: #eceff2; color: #747981"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6; margin-top: 12px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
          >
            <el-table-column prop="user_name" label="医生头像" width="80">
              <template slot-scope="scope">
                <div
                  style="border: solid 1px #d3d3d3; width: 42px; height: 42px"
                >
                  <img
                    :src="scope.row.head_img"
                    alt
                    style="width: 40px; height: 40px"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="doctor_name" label="医生信息">
              <template slot-scope="scope">
                <div>
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                    >{{ scope.row.doctor_name }}</span
                  >
                  <span v-if="scope.row.sex == 1" style="margin-left: 16px"
                    >男</span
                  >
                  <span v-if="scope.row.sex == 2" style="margin-left: 16px"
                    >女</span
                  >
                </div>
                <div>
                  <span>{{ scope.row.phone }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="所在省市">
              <template slot-scope="scope">
                <span>{{ scope.row.province_name }}</span>
                <span>{{ scope.row.city_name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hospital" label="医院名称"></el-table-column>
            <el-table-column
              prop="evaluate"
              label="平均评分"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="goods_evaluate"
              label="好评率"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="evaluate_num"
              label="评价数量"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="医生评价展示">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_show_evaluate"
                  @change="
                    (value) => setIsShowEvaluate(value, scope.row.doctor_id)
                  "
                  active-text="开启"
                  inactive-text="关闭"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1139')
                      : false
                  "
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1009')
                      : false
                  "
                  @click="toDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      is_test: 2,
      doctor_name: "",
      phone: "",
      prop: "",
      order_by: "",
      doc_msg: false,
      doctorId: "",
      is_show_evaluate: "-1",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        prop: this.prop,
        order_by: this.order_by,
        is_show_evaluate:
          this.is_show_evaluate == -1 ? "" : Number(this.is_show_evaluate),
      };
      console.log(data)
      this.axios
        .post("platform/doctor/getDoctorRevaluateList", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            let list =  res.data.list;
            list.forEach(ele=>{
              ele.is_show_evaluate = ele.is_show_evaluate==1?true:false
            })
            this.tableData =list
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    changeOrder(value) {
      this.prop = value.prop;
      //升序
      if (value.order == "ascending") {
        this.order_by = "asc";
      }
      //降序
      if (value.order == "descending") {
        this.order_by = "desc";
      }
      if (!value.order) {
        this.prop = "";
        this.order_by = "";
      }
      this.getList();
    },
    //详情
    toDetail(row) {
      this.$router.push({
        name: "evaluatedetail",
        query: {
          doctor_name: row.doctor_name,
          doctor_phone: row.phone,
        },
      });
    },//评价展示开关
  setIsShowEvaluate(value,doctor_id){
    let data = {
      doctor_id,
      is_show_evaluate:value?1:0
    }
    console.log(data)
     this.axios
        .post("platform/doctor/setIsShowEvaluate", data)
  },
  },
  activated() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>